// src/components/landing/SiteFooter.jsx
import React from 'react';
import Placeholder from './Placeholder';

const LINKS = [
  ['product', 'Product'], ['how', 'How it works'], ['analyses', 'Analyses'],
  ['for-you', 'For you'],
];

export default function SiteFooter({ onNavigate, onSignIn }) {
  const go = (id) => (e) => { e.preventDefault(); onNavigate(id); };
  return (
    <footer className="lp-footer">
      <div className="lp-wrap">
        <div className="lp-footer-grid">
          <div className="lp-footer-brand">
            <div className="logo" aria-hidden="true">VAUOM</div>
            <p className="lp-muted">© 2021-2025 VAUOM - Design to Construction Services.</p>
          </div>
          <nav aria-label="Footer" className="lp-footer-nav">
            <ul>
              {LINKS.map(([id, label]) => (
                <li key={id}><a href={`#${id}`} onClick={go(id)}>{label}</a></li>
              ))}
              <li><button type="button" className="lp-link" onClick={onSignIn}>Login</button></li>
            </ul>
          </nav>
          <div className="lp-footer-contact">
            <span className="lp-label">Contact</span>
            <Placeholder>CONTACT: email address</Placeholder>
          </div>
        </div>
        {/* Verbatim, and not decoration: it is the page's statement of what the
            product is not, and it protects the people relying on it. */}
        <p className="lp-honesty">
          VAUOM produces screening-grade analysis to support design decisions. It is not a
          substitute for a sanction drawing, a structural package, or a licensed professional&rsquo;s
          certification.
        </p>
      </div>
    </footer>
  );
}
